import React from 'react';
import FormGrid from '../features/analysis/components/ExamAnalysisForm';
import ExamAnalysis from '../features/analysis/components/ExamAnalysis';
import {
	PageSection,
	PageSectionVariants
} from '@patternfly/react-core';

import { Tabs, Tab, TabTitleText } from '@patternfly/react-core';
import { AuthContext } from 'shared/context/AuthContext';

class AnalysisTabs extends React.Component {
	static contextType = AuthContext
	constructor(props) {
		super(props);
		this.state = {
			activeTabKey: 0,
			analysis_data: [],
			isLoadedAnalysis: false,
			isLoadedExamAnalysis: false,
			examresults_data: [],
			examresults_path: window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'))+'/examresults'
		}

		this.handleTabClick = (event, tabIndex) => {
			this.setState({activeTabKey: tabIndex});
			//console.log(tabIndex);
			if (tabIndex === 0) {
				this.GetExamAnalysis(this.state.examresults_path);
			}
		}
	}
	
	GetAnalysis = async (args) => {
		fetch(`${this.props.state.api_url}/ti/api/v1${args}`, {
			'method': 'GET',
		  }
		)
		.then(resp => resp.json())
		.then(resp => this.setState({ 
		  analysis_data: resp, 
		  isLoadedAnalysis: true
		}))
		.catch(err => this.setState({ error: err, isLoadedAnalysis: false }));
	}
	GetExamAnalysis = async (args) => {
		fetch(`${this.props.state.api_url}/ti/api/v1${args}`, {
			'method': 'GET',
		  }
		)
		.then(resp => resp.json())
		.then(resp => this.setState({ 
			examresults_data: resp,
			isLoadedExamAnalysis: true
		}))
		.catch(err => this.setState({ error: err, isLoadedExamAnalysis: false }));
	}
	async componentDidMount() {
		this.props.state.activeItem = window.location.pathname;
		await this.GetExamAnalysis(this.state.examresults_path);
		await this.GetAnalysis(window.location.pathname);
	}
	componentDidUpdate(newProps, prevProps) {
		prevProps.location = window.location.pathname
		if (newProps.state.location !== prevProps.location) {
		  if(this.GetExamAnalysis(this.state.examresults_path)) {
			this.GetAnalysis(window.location.pathname);
			prevProps.location = window.location.pathname
			newProps.state.location = window.location.pathname
		  }
		}
	  }
  	render() {
		// console.log(this.context);
		// console.log(this.state.examresults_data);
		// console.log(this.state.analysis_data);
		// let execution_time = this.state.analysis_data.execution_time;
		// const examresults = this.props.analysis_state.examresults_data.examresults;
		return (
			<>
			{/* <Banner>
				<Level>
					<LevelItem></LevelItem>
					<LevelItem title="Execution time">
					{ execution_time }
					</LevelItem>
				</Level>
			</Banner> */}
			<PageSection variant={PageSectionVariants.light}>
				<Tabs
					//isFilled
					activeKey={this.state.activeTabKey}
					onSelect={this.handleTabClick}
					isBox={true}
					aria-label="Tabs in the filled example"
					role="region"
				>
					<Tab eventKey={0} role="region" title={<TabTitleText>Analizy egzaminów zawodowych</TabTitleText>} aria-label="Tabs filled example content users">
						<ExamAnalysis setSate={this.setState} analysis_state={this.state} state={this.props.state} />
					</Tab>
					{this.context.state.isAuthUser && this.context.state.userProfile?.is_superuser &&
						<Tab eventKey={1} title={<TabTitleText>Przygotowanie analizy egzaminu zawodowego</TabTitleText>}>
							<FormGrid setSate={this.setState} analysis_state={this.state} state={this.props.state} />
						</Tab>
					}					
				</Tabs>
			</PageSection>
			</>
		)
   }
}
export default AnalysisTabs;
